import { useQueryClient } from '@tanstack/react-query';
import { Button, Dropdown, Modal } from 'antd';
import apiCall from 'apps/investment/apiCalls/fundAccount';
import { usePostApi } from 'hooks/api';
import { useState } from 'react';

export const FundAccountActions = ({ record }) => {
  const [isUnlinkModalOpen, setIsUnlinkModalOpen] = useState(false);
  const queryClient = useQueryClient();

  const { post: unlinkFundAccount, isLoading: isUnlinking } = usePostApi(
    apiCall.unlink,
    {
      onSuccess: () => {
        setIsUnlinkModalOpen(false);
        // UnlinkFundAccount flips the account to "unlinked" and deletes its
        // fund orders, program orders, transactions and e-contracts inside a
        // single committed transaction, so both the account and the order
        // lists are stale once it resolves.
        queryClient.invalidateQueries({ queryKey: [apiCall.list.queryKey] });
        queryClient.invalidateQueries({ queryKey: [apiCall.detail.queryKey] });
      },
    }
  );

  const isUnlinked = record.status === 'unlinked';

  const dropdownItems = [];

  if (!isUnlinked) {
    dropdownItems.push({
      key: 'unlink',
      label: 'Unlink',
      danger: true,
      onClick: () => setIsUnlinkModalOpen(true),
    });
  }

  if (dropdownItems.length === 0) {
    return null;
  }

  return (
    <>
      <Dropdown menu={{ items: dropdownItems }} trigger={['click']}>
        <Button loading={isUnlinking}>Actions ▾</Button>
      </Dropdown>

      <Modal
        title="Unlink Fund Account"
        open={isUnlinkModalOpen}
        onOk={() => unlinkFundAccount({ id: record.id })}
        onCancel={() => setIsUnlinkModalOpen(false)}
        okText="Confirm Unlink"
        okButtonProps={{ danger: true, loading: isUnlinking }}
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to <strong>unlink</strong> this fund account?
        </p>
        <p>
          This will delete all related fund orders and program orders, and recalculate the portfolio.{' '}
          <strong>This action cannot be undone.</strong>
        </p>
        <p>
          Please confirm the user has already been unlinked on the partner platform before proceeding.
          Partners do not yet support systematic unlinking — this action only removes the account on Stag's side.
        </p>
      </Modal>
    </>
  );
};
